import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  MultiSelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';

interface IGetAddDacScenariosFormObjectProps {
  store: DacScenariosRepository;
  passingModeOptions?: SelectOption[];
}

export function addDacScenariosFormObject({ store, passingModeOptions }: IGetAddDacScenariosFormObjectProps): DynamicForm {
  const nameField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.nom.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'nom'),
    props: {
      value: store.getNestedObservable('dto', 'nom'),
      onChange: (value: string) => {
        store.setNested('dto', 'nom', value);
      },
    },
  };
  const descriptionField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.description.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'description'),
    props: {
      value: store.getNestedObservable('dto', 'description'),
      onChange: (value: string) => {
        store.setNested('dto', 'description', value);
      },
    },
  };
  const codeField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.code.label',
    variant: FieldVariant.TEXT,
    error: store.getNestedObservable<string>('errors', 'code'),
    isRequired: true,
    props: {
      value: store.getNestedObservable('dto', 'code'),
      onChange: (value: string) => {
        store.setNested('dto', 'code', value);
      },
    },
  };

  const passingModeField: DynamicField<MultiSelectFieldProps> = {
    label: 'settings.dacScenarios.form.passingMode.label',
    variant: FieldVariant.MULTISELECT,
    isRequired: true,
    props: {
      value: store.getObservable('passingModeSelected'),
      onSelectChange: (value: SelectOption[]) => {
        store.setNested(
          'dto',
          'modePassationIds',
          value.map(option => option.code)
        );
        store.set('passingModeSelected', value);
      },
      options: passingModeOptions,
    },
  };

  return {
    title: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nameField, descriptionField],
          },
          {
            fields: [codeField, passingModeField],
          },
        ],
      },
    ],
  };
}
